/**
 * Storage-location formatting shared by the API (PDF), the Admin detail page and
 * the bulk wine list so the three never drift.
 *
 * A bulk wine's location records where the wine is physically held — buyers use it
 * to estimate freight. It is deliberately region-level: no company name, no street
 * address. It is independent of the origin region, so stored wine may sit in a
 * different region (or country) from where its fruit was grown.
 */

/**
 * Format a stored location as "<sub-region>, <region>", dropping whichever part is
 * missing (e.g. "Awatere Valley, Marlborough", "Marlborough", or "N/A" when unset).
 *
 * The region is included alongside the sub-region because sub-region names alone
 * ("Bridge Pa Triangle") are not widely recognisable enough to gauge freight from.
 */
export const formatLocationLabel = (
  subRegionName: string | null | undefined,
  regionName: string | null | undefined,
): string => {
  const parts = [subRegionName, regionName]
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter((part) => part.length > 0 && part !== 'N/A');

  return parts.length > 0 ? parts.join(', ') : 'N/A';
};
